export const impactFairlyBlock = `
_type == 'impactFairlyBlock' => {
  list[]{
    ...,
    "unit": unit[_key == $lang][0].value,
    "description": description[_key == $lang][0].value,
  }
}
`
